import { useEffect, useState } from "react";
import { DiagnosticsPathNormativitiesSection } from "../../../widgets/diagnostics/diagnosticsPathNormativitiesSection";
import { DiagnosticsYearFilters } from "../../../widgets/diagnosticsYearFilters";
import { useNavigate } from "react-router-dom";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";
import PathNormativitiesListSearchBar from "../../../widgets/searchbars/pathNormativitiesListSearchBar/PathNormativitiesListSearchBar";

// Компонент - страница состояния дорог в разделе диагностики.
export function DiagnosticsPathNormativitiesSectionPage() {
    const navigate = useNavigate()
    const [windowIsSmall, setWindowIsSmall] = useState(false);
    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)
    const searchLineIsShown = useAppSelector(state => state.contentHeader.searchLineIsShown)

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setWindowIsSmall(contentHeaderWidth < 720);
    }, [sideBarState, navigate])

    useEffect(() => {
        const hasSeenYearForMobile = getItemWebStorage('diagnosticsYearFilters')?.pathNormativitiesInfoSeen
        if (!hasSeenYearForMobile && windowIsSmall) {
            navigate('/app/diagnostics/pathNormativities/filters')
        }
    }, [windowIsSmall])

    return (
        <>
            <ContentHeader title="Доля автомобильных дорог в нормативном состоянии" type="pathNormativitiesInfo" />
            <div className="path-normativities-page-div">
                {!windowIsSmall && <DiagnosticsYearFilters type="header" filterType="PathNormativitiesInfo" />}
                {searchLineIsShown && <PathNormativitiesListSearchBar />}
                <div className="path-normativities-content">
                    <DiagnosticsPathNormativitiesSection />
                </div>
            </div>
        </>
    );
}